import React, { useState } from 'react';
import { X, Send, Loader2 } from 'lucide-react';

const ContactModal = ({ open, onClose, onSubmit }) => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', phone: '', message: '' });
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await onSubmit(form);
    setLoading(false);
    if (ok) {
      setForm({ name: '', email: '', subject: '', phone: '', message: '' });
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-[95] flex items-center justify-center bg-black/70 p-4 animate-in fade-in duration-200"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-2xl rounded-lg shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-gradient-to-br from-[#2d4a1a] to-[#5a8c26] p-8 text-white">
          <button onClick={onClose} className="absolute top-4 right-4 text-white/80 hover:text-white">
            <X className="w-5 h-5" />
          </button>
          <span className="text-[#a3d859] text-xs font-bold tracking-[4px]">CONTACT US</span>
          <h2 className="text-3xl md:text-4xl font-bold mt-2" style={{ fontFamily: "'Playfair Display', serif" }}>
            Get in Touch
          </h2>
          <p className="mt-2 text-white/80 text-sm">
            We'd love to hear from you. Send us a message and our team will reach out shortly.
          </p>
        </div>

        <form onSubmit={submit} className="p-8 space-y-4">
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-[11px] font-bold tracking-widest text-[#5a6b3a] mb-1.5">NAME *</label>
              <input
                required
                value={form.name}
                onChange={update('name')}
                className="w-full border border-[#dde3d0] focus:border-[#8ec045] outline-none px-3 py-2.5 text-sm transition-colors"
                placeholder="Your name"
              />
            </div>
            <div>
              <label className="block text-[11px] font-bold tracking-widest text-[#5a6b3a] mb-1.5">EMAIL *</label>
              <input
                required
                type="email"
                value={form.email}
                onChange={update('email')}
                className="w-full border border-[#dde3d0] focus:border-[#8ec045] outline-none px-3 py-2.5 text-sm transition-colors"
                placeholder="you@example.com"
              />
            </div>
            <div>
              <label className="block text-[11px] font-bold tracking-widest text-[#5a6b3a] mb-1.5">PHONE</label>
              <input
                value={form.phone}
                onChange={update('phone')}
                className="w-full border border-[#dde3d0] focus:border-[#8ec045] outline-none px-3 py-2.5 text-sm transition-colors"
                placeholder="+91 90000 00000"
              />
            </div>
            <div>
              <label className="block text-[11px] font-bold tracking-widest text-[#5a6b3a] mb-1.5">SUBJECT</label>
              <input
                value={form.subject}
                onChange={update('subject')}
                className="w-full border border-[#dde3d0] focus:border-[#8ec045] outline-none px-3 py-2.5 text-sm transition-colors"
                placeholder="Project inquiry"
              />
            </div>
          </div>
          <div>
            <label className="block text-[11px] font-bold tracking-widest text-[#5a6b3a] mb-1.5">MESSAGE *</label>
            <textarea
              required
              rows={4}
              value={form.message}
              onChange={update('message')}
              className="w-full border border-[#dde3d0] focus:border-[#8ec045] outline-none px-3 py-2.5 text-sm transition-colors resize-none"
              placeholder="Tell us more about your requirement..."
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-[#8ec045] hover:bg-[#7cad38] text-white px-6 py-3 text-[13px] font-bold tracking-wider disabled:opacity-70 transition-colors"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
            {loading ? 'SENDING...' : 'SEND MESSAGE'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactModal;
